import { render, staticRenderFns } from "./ButtonCreate.vue?vue&type=template&id=00924254&scoped=true&"
import script from "./ButtonCreate.vue?vue&type=script&lang=js&"
export * from "./ButtonCreate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCreate.vue?vue&type=style&index=0&id=00924254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00924254",
  null
  
)

export default component.exports